import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { ApplicationPool } from "../services/application.pool";
import { ActionService } from "../services/action.service";

@Injectable({
  providedIn: "root",
})
export class LoginGuard {
  public constructor(
    private router: Router,
    private dataPool: ApplicationPool,
    private service: ActionService
  ) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (
      this.service.client.Token &&
      this.service.client.Token.length > 0 &&
      this.service.client.Token != "null"
    ) {
      if (this.dataPool.data?.User) {
        this.router.navigate(["/"], { replaceUrl: true });
      }
      return true;
    } else {
      return true;
    }
  }
}
